import Api from 'entities/helpers/api';
import ErrorLogger from 'entities/helpers/error-log-helper';

/**
 * Fetch the recent call history for a contact, each call enriched with live Twilio
 * Voice Insights and a plain-English summary. Returns [] on error so the modal can
 * render an empty state rather than break the dialer.
 *
 * @param {number|string} contactId
 * @returns {Promise<Array>} list of { call, insights, summary }
 */
export const getContactCallHistory = async (contactId) => {
  try {
    return (await Api.OUTREACH.CONTACT_CALL_HISTORY.get({ urlArgs: { contactId } })) || [];
  } catch (error) {
    ErrorLogger.error('Failed to load contact call history', { extra: { error, page_name: 'dialer' } });
    return [];
  }
};
